import { forwardRef } from 'react'
import GridRoot, { Props, Ref } from './Grid'

function Grid(props: Props, ref?: Ref) {
  return <GridRoot {...props} ref={ref} />
}

export default forwardRef(Grid)
